import { IconChevronDownFilled, IconChevronUpFilled } from '@zillow/constellation-icons';
import { Collapsible, ProgressStepper, TextButton } from '@zillow/constellation-10';

export type Signee = {
  type: string;
  text: string;
};
type Props = {
  signeeList: Array<Signee>;
};

const WhoHasSignedDescription = ({ signeeList }: Props) => {
  function renderExpandedContent(): JSX.Element | null {
    if (signeeList == null) {
      return null;
    }

    const isComplete = signeeList.every((signee) => signee.type !== 'unsigned');

    const steps = signeeList.map((signee) => ({
      label: signee.text,
      tone: signee.type !== 'unsigned' ? 'complete' : null,
    }));

    return (
      <ProgressStepper activeStepIndex={isComplete ? signeeList?.length : -1} orientation="vertical" steps={steps} />
    );
  }

  return (
    <>
      {signeeList?.length > 0 && (
        <Collapsible
          // eslint-disable-next-line react/no-children-prop
          children={(collapsed: boolean, onToggleExpansion: () => void) => (
            <div>
              <TextButton
                icon={collapsed ? <IconChevronDownFilled /> : <IconChevronUpFilled />}
                onClick={onToggleExpansion}
                iconPosition="end"
                css={{ marginBottom: collapsed ? 0 : '200' }}
              >
                Who has signed?
              </TextButton>
              {collapsed ? null : renderExpandedContent()}
            </div>
          )}
        />
      )}
    </>
  );
};

export default WhoHasSignedDescription;
